// extracted by mini-css-extract-plugin
export default {"black":"#000","white":"#fff"};